<article
	obg-m-content-widget
	*ngFor="let widget of contentWidgets$ | async; let even = even; trackBy: trackByWidget"
	[contentWidget]="widget"
	[alternativeView]="even"
></article>
